import axios from 'axios';

import ENDPOINT from '../../context/EndPoint';

const GetStudentCourseBadges = async ({payload}) => {

          const formData = new FormData();

           formData.append('session',payload.user);
           formData.append('user_id',payload.user_id);
           
           formData.append('course_url',payload.course_url);
           

           try{
               const res = await axios.post(ENDPOINT+"admin-student-badges.php", formData,{
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                });
                if(res.data){
                    return res.data
             
                }
           }
           catch(error){

return error
           }

     




}

export default GetStudentCourseBadges